import React from 'react';
import { i18n } from '@international/mastodon-i18n';
import useT from 'hooks/useT';

import IconPanel from '../IconPanel';
import FaqButton from '../fields/FaqButton';

import suspendedIcon from '../../images/icons/Suspended.svg';

const Unavailable = (): JSX.Element => {
  // ECDEX-3440: `useT()` re-renders this component on `i18n.setLocale()`, so
  // the icon's alt text follows the locale like the `<T>` title/details do.
  // The string comes from `i18n.getStr` (same as WorkOSDobForm) rather than
  // `useT().t`, which reads a separate i18next instance under vitest.
  useT();
  return (
    <IconPanel
      translationKey='components.Verification.Unavailable'
      icon={<img src={suspendedIcon} alt={i18n.getStr('components.expired')} />}
      data-testid='verification-unavailable'
    >
      <div className='text-center'>
        <FaqButton />
      </div>
    </IconPanel>
  );
};

export default Unavailable;
